// opervex-frontend/src/index.js

import ReactDOM from "react-dom/client";
import App from "./App";
import ConfirmationProvider from "./components/ConfirmationModal/ConfirmationProvider";
import ClearingModalProvider from "./components/Financial/ClearingModalProvider";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import axios from "axios";
import OpervexStorage from "./utils/OpervexStorage";

axios.interceptors.request.use((config) => {
  const user = OpervexStorage.getUser();
  if (user?.token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      OpervexStorage.clear();

      const tenantId = OpervexStorage.getTenantIdFromPath();
      window.location.href = tenantId ? `/${tenantId}/Login` : "/Login";
    }
    return Promise.reject(error);
  },
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfirmationProvider>
    <App />
    <ClearingModalProvider />
  </ConfirmationProvider>,
);
